import React from 'react';
import PropTypes from 'prop-types';
import { Select, Checkbox, Divider } from 'antd';
import styled from 'styled-components';

const FieldWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

const FieldLabel = styled.label`
	font-size: 14px;
	font-weight: 500;
	color: #374151;
`;

const Required = styled.span`
	color: #ef4444;
	margin-left: 2px;
`;

const StyledSelect = styled(Select)`
	width: 100%;

	.ant-select-selector {
		min-height: 40px;
		border-radius: 6px !important;
		border: 1px solid #d1d5db !important;
	}
`;

const SelectAllRow = styled.div`
	padding: 6px 12px;
	cursor: pointer;

	&:hover {
		background: #f5f7fa;
	}
`;
export const ALL_VALUE = '__ALL__';

function MultiSelectDropdown({
	label,
	required,
	placeholder,
	options,
	value,
	onChange,
	disabled,
	allSentinel,
	onSearch,
	searchLoading,
}) {
	const allValues = options.map((o) => o.value);
	const selected = value || [];
	const allSelected = allValues.length > 0 && selected.length === allValues.length;
	const someSelected = selected.length > 0 && !allSelected;
	const renderOptions = allSentinel ? [{ value: ALL_VALUE, label: 'All' }, ...options] : options;
	const handleChange = (vals) => {
		if (!allSentinel) {
			onChange(vals);
			return;
		}
		if (vals[vals.length - 1] === ALL_VALUE) {
			onChange([ALL_VALUE]);
			return;
		}
		onChange(vals.filter((v) => v !== ALL_VALUE));
	};

	const toggleAll = (e) => {
		onChange(e.target.checked ? allValues : []);
	};

	return (
		<FieldWrapper>
			{label ? (
				<FieldLabel>
					{label}
					{required ? <Required>*</Required> : null}
				</FieldLabel>
			) : null}
			<StyledSelect
				mode="multiple"
				placeholder={placeholder || 'Select'}
				value={selected}
				onChange={handleChange}
				disabled={disabled}
				showSearch
				showArrow
				maxTagCount="responsive"
				optionFilterProp="label"
				menuItemSelectedIcon={null}
				{...(onSearch ? { onSearch, loading: searchLoading } : {})}
				// eslint-disable-next-line react/no-unstable-nested-components
				dropdownRender={(menu) =>
					allSentinel ? (
						menu
					) : (
						<>
							<SelectAllRow onMouseDown={(e) => e.preventDefault()}>
								<Checkbox
									checked={allSelected}
									indeterminate={someSelected}
									onChange={toggleAll}
								>
									Select All
								</Checkbox>
							</SelectAllRow>
							<Divider style={{ margin: 0 }} />
							{menu}
						</>
					)
				}
				optionLabelProp="label"
			>
				{renderOptions.map((opt) => (
					<Select.Option key={opt.value} value={opt.value} label={opt.label}>
						<Checkbox
							checked={selected.includes(opt.value)}
							style={{ marginRight: 8 }}
						/>
						{opt.label}
					</Select.Option>
				))}
			</StyledSelect>
		</FieldWrapper>
	);
}

MultiSelectDropdown.propTypes = {
	label: PropTypes.string,
	required: PropTypes.bool,
	placeholder: PropTypes.string,
	options: PropTypes.arrayOf(PropTypes.object),
	value: PropTypes.array,
	onChange: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	allSentinel: PropTypes.bool,
	onSearch: PropTypes.func,
	searchLoading: PropTypes.bool,
};

MultiSelectDropdown.defaultProps = {
	label: '',
	required: false,
	placeholder: 'Select',
	options: [],
	value: [],
	disabled: false,
	allSentinel: false,
	onSearch: undefined,
	searchLoading: false,
};

export default MultiSelectDropdown;
